// i18n must initialise before any component renders so `t()` and the stored
// language are ready on first paint.
import './i18n';

import App from './App';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App/>);
